// @flow
import type { ExtentType } from 'catena/er2_map_userlayers/js/reducers/map'
import * as actionTypes from 'catena/er2_map_userlayers/js/constants/action_types'

export type IdentifyFeatureType = {
    geometry: string,
}

export type IdentifyLayersType = {
    layer_name: string,
    features: IdentifyFeatureType[],
}

export type IdentifyType = {
    extent: ExtentType,
    layers: IdentifyLayersType[],
    identifyHandled: boolean,
}

type ActionType = {
    identifyState: IdentifyType,
    type: string,
}

const initialState = {
    extent: [0, 0, 0, 0],
    layers: [],
    identifyHandled: true,
}

export default function identify(state: IdentifyType = initialState, action: ActionType) {
    let ret = state
    if (action.type === actionTypes.SET_IDENTIFY_FEATURES) {
        ret = {
            ...state,
            extent: action.identifyState.extent,
            layers: action.identifyState.layers,
            identifyHandled: false,
        }
    } else if (action.type === actionTypes.SET_IDENTIFY_HANDLED) {
        ret = {
            ...state,
            identifyHandled: true,
        }
    }
    return ret
}
